function isIE(userAgent) {
    userAgent = userAgent || navigator.userAgent;
    return userAgent.indexOf("MSIE ") > -1 || userAgent.indexOf("Trident/") > -1 || userAgent.indexOf("Edge/") > -1;
}

(function($){

	$(document).ready(function(){
		wrap_iframes();		

		// set all external links to open in new tab
	    $('a').each(function() {
			var a = new RegExp('/' + window.location.host + '/');

			if((!a.test(this.href) && this.href.indexOf('mailto') != 0 && this.href != 'javascript:;') || this.href.indexOf('.pdf') >= 0) {
            	$(this).prop('target','_blank');
            	$(this).addClass('external-link');
        	}	
			
	    });

		function wrap_iframes() {
			// $('iframe[src*="vimeo"]').wrap("<div class='iframe-wrapper inline-vimeo'></div>");
			$('iframe[src*="youtube"]').wrap("<div class='iframe-wrapper inline-youtube'></div>");
		}
		
	});
	
})(jQuery);
// };